export { default } from 'react-bootstrap/Media';
